<div class="px-3 row px-md-2">
  <div class="col-12 col-md-3 col-lg-3 col-xl-3">
    <a [routerLink]="!deleted ? ('/' + companyGroupCode + basketUrl) : ('/' + companyGroupCode + '/baskets/archive/' + basket['id'])" class="text-decoration-none">
      <h5>{{basket['name']}}</h5>
      @if (basket.locked && !checkIfOrdered() && !deleted) {
        <p class="text-danger" type="danger">{{"BASKET_LOCKED"|translate}}</p>
      }
      @if (basket.active && !basket.pre_order && !deleted) {
        <span class="px-2 py-1 me-1 badge bg-success badge-pill">{{'ACTIVE' | translate}}</span>
      }
      @if (basket.pre_order) {
        <span class="px-2 py-1 me-1 badge bg-warning badge-pill">{{'PREORDER' | translate}} </span>
      }
      @if (basket.pre_order) {
        <span class="px-2 py-1 me-1 badge bg-info badge-pill ps-3 position-relative">
          <i class="material-icons position-absolute" style="top: 3px; left: 3px; font-size: 12px;">{{(basket.preorder_type === 'Parts' ? 'settings' : 'pedal_bike')}}</i>
          <span class="ms-1">{{(basket.basket_type === 'PreOrderParts' ? 'PARTS' : 'BICYCLES') | translate}}</span>
        </span>
      }
      @if (checkIfOrdered() && basket['order_number']) {
        <small>{{"ORDER_NUMBER"|translate}}: {{basket['order_number']}}</small>
      }
    </a>
    @if (basket.locked && !checkIfOrdered()) {
      <button class="mt-3 btn btn-sm btn-outline-primary d-block" (click)="unlockBasket()">{{ 'UNLOCK_BASKET' | translate }}</button>
    }
  </div>
  <div class="col-12 col-md-2">{{basket['user_name']}}<br><small>{{getLastEditTime(basket['last_edit'])}}</small></div>
  <div class="col-8 col-md-2" [ngClass]="{'d-none d-sm-block': showroomMode}">
    @if (!deleted && !showroomMode) {
      {{ "AMOUNT" | translate}}:
      <app-article-sum [netPrice]="basket['total_price']" [amount]="1"></app-article-sum>
    }
  </div>
  <div class="col-md-3"  [ngClass]="showroomMode ? 'col-12' : 'col-4'">
    @if (basket) {
      <app-item-count [companyGroupCode]="companyGroupCode" [items]="basket['items']" [preorder]="basket.pre_order" [item_count]="basket?.item_count"></app-item-count>
    }
  </div>
  <div class="pe-0 col-8 col-md-2 col-lg-1 col-xl-1 d-flex align-items-center">
    @if (!checkIfOrdered() && !basket.locked && !deleted) {
      <a (click)="deleteBasket()" class="px-0 btn btn-link text-danger px-md-2"
      >{{'DELETE'|translate}}</a>
    }
    @if (checkIfOrdered()) {
      <span class="d-block d-sm-none">{{basket["last_edit"]}}</span>
    }
  </div>
  <div class="col-4 col-md-1 d-flex align-items-center">
    @if (!deleted) {
      <a class="btn btn-primary ms-auto"
        [queryParams]="{basePage: basePage}"
        [routerLink]="'/' + companyGroupCode + basketUrl">{{
        'VIEW' |
      translate }}</a>
    }
    @if (deleted) {
      <a class="btn btn-primary float-md-right"
        [routerLink]="'/' + companyGroupCode + '/baskets/archive/' + basket['id']">{{
        'VIEW' |
      translate }}</a>
    }
  </div>
</div>
